import { render, staticRenderFns } from "./fleet.vue?vue&type=template&id=3fcf62ce"
import script from "./fleet.vue?vue&type=script&lang=js"
export * from "./fleet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports